import axios from "axios";
import { getApiUrl, getApiUrlWithVersion } from "./environmentService";
import { store as reduxStore } from "../store/store";
import {
  setAccessToken,
  setUserDetails,
  clearMfaPending,
} from "../store/slices/authUserSlice";

const getAuthHeaders = () => {
  const token = reduxStore.getState().authUser.accessToken;
  return { Authorization: token };
};

// --- Setup Flow (user is authenticated) ---

export const setupMfa = async (phoneNumber: string) => {
  await axios.post(
    `${getApiUrlWithVersion()}/mfa/setup`,
    { phone_number: phoneNumber },
    { headers: getAuthHeaders() }
  );
};

export const verifySetup = async (code: string) => {
  const response = await axios.post(
    `${getApiUrlWithVersion()}/mfa/verify_setup`,
    { code },
    { headers: getAuthHeaders() }
  );
  return response.data;
};

export const disableMfa = async () => {
  await axios.delete(`${getApiUrlWithVersion()}/mfa`, {
    headers: getAuthHeaders(),
  });
};

export const getMfaStatus = async () => {
  const response = await axios.get(`${getApiUrlWithVersion()}/mfa/status`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const resendSetupCode = async () => {
  await axios.post(
    `${getApiUrlWithVersion()}/mfa/resend`,
    {},
    { headers: getAuthHeaders() }
  );
};

export const challengeMfa = async () => {
  const response = await axios.post(
    `${getApiUrlWithVersion()}/mfa/challenge`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};

// --- Login Flow (user is NOT authenticated, only has mfa_token) ---

export const verifyMfaLogin = async (mfaToken: string, code: string) => {
  const response = await axios.post(`${getApiUrl()}/auth/mfa/verify`, {
    mfa_token: mfaToken,
    code,
  });

  const token = response.headers.authorization;
  const { data } = response.data;

  reduxStore.dispatch(
    setUserDetails({
      email: data.user.email,
      organization: data.user.organization,
      mfa_enabled: data.user.mfa_enabled,
    })
  );
  reduxStore.dispatch(setAccessToken(token));
  reduxStore.dispatch(clearMfaPending());

  return data;
};

export const resendMfaLoginCode = async (mfaToken: string) => {
  await axios.post(`${getApiUrl()}/auth/mfa/resend`, {
    mfa_token: mfaToken,
  });
};
